import type { ReactNode } from 'react';

interface ProposalContainerProps {
  children: ReactNode;
  className?: string;
}

/**
 * Shared container for proposal action renderers.
 * Provides consistent spacing between child elements.
 * All renderers should wrap their full-mode content in this container
 * to ensure uniform vertical rhythm across proposal types.
 */
export function ProposalContainer({
  children,
  className = '',
}: ProposalContainerProps) {
  return <div className={`space-y-3 ${className}`}>{children}</div>;
}
